/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { sendGTMCookieDialogAcceptEvent } from '@/data/events/handlers/gtm/CookieDialogAccept';
import { GTMCookieDialogAcceptPayload } from '@/data/types/GTM';

type CookieDialogAcceptDelegatorProps = {
	gtm?: GTMCookieDialogAcceptPayload;
};

export const cookieDialogAcceptDelegator = async (payload: CookieDialogAcceptDelegatorProps) => {
	const { gtm } = payload;
	if (gtm) {
		await sendGTMCookieDialogAcceptEvent(gtm);
	}
};
